import { render, staticRenderFns } from "./the-system-bar-container.vue?vue&type=template&id=419b88b1&"
import script from "./the-system-bar-container.vue?vue&type=script&lang=js&"
export * from "./the-system-bar-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports